<section class="section grey-900" *ngIf="_videoData">
  <div class="section-container">
    <div class="about-hero-content-box">
      <h2 class="section-heading white align-l">
        {{ _videoData.title }}
      </h2>
      <div
        class="landing-hero-content white"
        [innerHtml]="_videoData.content | toHtml"
      ></div>
    </div>
    <div class="product-blog-video">
      <video
        width="100%"
        height="100%"
        #videoPlayer
        class="myvid"
        src="{{_videoData?.image?.[0]?.fields?.file?.url}}#t=1"
        (play)="onPlay()"
        (pause)="onPause()"
        controls
        [poster]=""
      >
        <source
          [src]="_videoData?.image?.[0]?.fields?.file?.url"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</section>
